import { render } from "./Direcciones.vue?vue&type=template&id=224b73f0"
import script from "./Direcciones.vue?vue&type=script&lang=js"
export * from "./Direcciones.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__